"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BaseDataService = void 0;

var _InterceptorList = require("./InterceptorList");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Like the name implies, this is intended to be used as a base data service. It uses an async pipeline model to
 * allow child services to create an execution plan (using request and response interceptors). This also allows
 * external consumers of child services to modify requests as needed for their needs (for instance, to inject
 * an auth token, or a version header).
 */
var BaseDataService =
/*#__PURE__*/
function () {
  function BaseDataService() {
    _classCallCheck(this, BaseDataService);

    var interceptors = new _InterceptorList.InterceptorList();
    Object.defineProperty(this, 'interceptors', {
      get: function get() {
        return interceptors;
      }
    });
  }
  /**
   * Override this in child classes. This method should actually execute the API call. Request interceptors are
   * called before this, and response interceptors are called afterwards.
   * @protected
   */


  _createClass(BaseDataService, [{
    key: "_send",
    value: function _send() {}
    /**
     * Creates and executes a async pipeline
     * @param config - argument passed to each step of the pipe.
     * @returns {Promise<any>}
     */

  }, {
    key: "request",
    value: function request(config) {
      // Stores the execution plan.
      var requestChain = []; // Request interceptors will be called first.

      this.interceptors.request.forEach(function (interceptor) {
        requestChain.push(interceptor.onSuccess, interceptor.onError);
      }); // Then the method that actually executes the $http request. The error handler is undefined because response
      // interceptors should handle errors.

      requestChain.push(this._send.bind(this), undefined); // Finally all response interceptors will execute.

      this.interceptors.response.forEach(function (interceptor) {
        requestChain.push(interceptor.onSuccess, interceptor.onError);
      }); // Set up the pipeline as async...

      var promise = Promise.resolve(config); // ...and execute it.

      while (requestChain.length) {
        promise = promise.then(requestChain.shift(), requestChain.shift());
      }

      return promise;
    }
  }]);

  return BaseDataService;
}();

exports.BaseDataService = BaseDataService;


//////////////////
// WEBPACK FOOTER
// ./node_modules/lbs-pi-platform-access/es/core/BaseDataService.js
// module id = 86
// module chunks = 0